import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { recognizeItems } from '../data/finanza';
export function Recognize() {
  return <section className="w-full bg-[#1E2B58] px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-261" data-mp="30xq6vhilcqwd">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-262" data-mp="2w56qydwfljoe">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-263" data-mp="2r7wvagig8bs4">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-264" data-mp="2r5kbryx1ltcy">
            Educazione finanziaria in classe? Ti è mai successo?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-265" data-mp="2i5f8o0yvth4l">
            Se rispondi sì ad almeno una domanda, FINANZA PRONTA™ è per te.
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-serif text-2xl italic text-[#F2B134] transition-colors duration-150 ease-out hover:text-stone-50" data-id="element-266" data-mp="289kjen05knsu">
            Meriti un modo più semplice
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-267" data-mp="6hz1m622ball" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-268" data-mp="3nnqgvhkqgkqt">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-269" data-mp="3elqxwjq5r6l8">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-[#F2B134]" data-id="element-270" data-mp="3eo3fuwvx1gya">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-271" data-mp="b5s7i67s2go6" />
                </span>
                <div data-id="element-272" data-mp="3sm1ormrgwl6e">
                  <h3 className="font-serif text-2xl leading-tight sm:text-3xl" data-id="element-273" data-mp="3smjsf4ggm1oc">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-stone-50/70" data-id="element-274" data-mp="1ep7l7ql47qh">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}